/**
 * Software Secure Crypto Robustness.
 *
 *
 * @beta
 */
export const SW_SECURE_CRYPTO = 'SW_SECURE_CRYPTO'
